import './App.css';
import './tailwind.css';
import Logo from "./assets/img/logo-light.png";
import ThemeRoute from "./themes/ThemeRoute";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Toaster} from "react-hot-toast";
// Modals
import NoImageDefaultModals from "./themes/NoImageDefault/components/DrawerModal";
import ImageDefaultModals from "./themes/ImageDefault/components/DrawerModal";
import Theme3Modals from "./themes/Theme3/components/DrawerModal";
import Theme4Modals from "./themes/Theme4/components/DrawerModal";
import ItalianModals from "./themes/Italian/components/DrawerModal";

function App() {
  const {locale, theme, restaurantId} = useSelector(state => state.app)
  const {i18n} = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(locale).then();
    document.documentElement.lang = locale;
    document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
  }, [locale, i18n]);

  const modals = {
    "no_image_default": NoImageDefaultModals,
    "image_default": ImageDefaultModals,
    "theme_3": Theme3Modals,
    "italian": ItalianModals,
    "theme_4": Theme4Modals,
  }
  const minipanIds = [
    "fcbe7bd5-85c0-4515-94c4-a4c01c7fe98c",
    "441cb8a0-15d6-4df7-84ff-3c45938bdebe",
    "908b104d-814d-4a33-8c38-b4c99e0d8699",
    "8bd2b802-9b35-4906-94c6-a3c884bbd909",
    "39b93c92-d3ee-468b-98ee-17b323ed814a",
    "73e00fc8-bab6-4693-9777-bdf276309799",
    "5c497c43-1288-448e-b636-6f322ea9ab5f",
    "d9d8c614-7910-4621-a1f3-162fc9b0c176",
    "31fac5f9-97bb-42a9-8053-73032e038296",
  ]

  return (
    <>
      <ThemeRoute/>
      {
        React.createElement(modals[theme] || modals['no_image_default'])
      }
      <Toaster/>

      <div className={'swal2-container w-1 h-1 hidden'}></div>
      {!minipanIds.includes(restaurantId) && (
        <div className={'fixed bottom-[100px] z-[3001] rotate-90 left-[-35px] text-center flex justify-center'}>
          <div className={'w-[80px] p-1 bg-[#021321] rounded-t-xl text-[#fff] flex justify-center items-center'}>
            <a href="https://kardoapp.com/" target={'_blank'} rel={"noreferrer"}
               className={'flex justify-center items-center'}>
              <img src={Logo} width={'50%'} alt={'Logo'}/>
            </a>
          </div>
        </div>
      )}

    </>
  );
}

export default App;
